"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _LinkFormPagesSelector = _interopRequireDefault(require("./LinkFormPagesSelector"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIPopoverHeader = _interopRequireDefault(require("UIComponents/tooltip/UIPopoverHeader"));

var _UIPopoverBody = _interopRequireDefault(require("UIComponents/tooltip/UIPopoverBody"));

var _UIPopoverFooter = _interopRequireDefault(require("UIComponents/tooltip/UIPopoverFooter"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _keyCodes = require("draft-plugins/lib/keyCodes");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var toI18nText = function toI18nText(name) {
  return _I18n.default.text("draftPlugins.linkPlugin." + name);
};

var POPOVER_WIDTH = 328;
var PAGES_POPOVER_WIDTH = 425;

var _default = (0, _createReactClass.default)({
  displayName: "LinkForm",
  propTypes: {
    isNew: _propTypes.default.bool.isRequired,
    headerText: _propTypes.default.string.isRequired,
    text: _propTypes.default.string,
    url: _propTypes.default.string.isRequired,
    pages: _propTypes.default.array.isRequired,
    isTargetBlank: _propTypes.default.bool.isRequired,
    isNoFollow: _propTypes.default.bool.isRequired,
    showText: _propTypes.default.bool,
    onChange: _propTypes.default.func.isRequired,
    onConfirm: _propTypes.default.func.isRequired,
    onCancel: _propTypes.default.func.isRequired,
    onRemove: _propTypes.default.func.isRequired,
    hideTargetConfiguration: _propTypes.default.bool,
    hideNoFollowConfiguration: _propTypes.default.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      headerText: '',
      pages: [],
      showText: true,
      hideTargetConfiguration: false,
      hideNoFollowConfiguration: false
    };
  },
  cancelOrConfirmKeys: function cancelOrConfirmKeys(e) {
    switch (e.keyCode) {
      case _keyCodes.ESCAPE:
        e.preventDefault();
        this.props.onCancel();
        return;

      case _keyCodes.ENTER:
        e.preventDefault();

        if (this.canSubmit()) {
          this.props.onConfirm();
          return;
        }

        return;

      default:
        return;
    }
  },
  handleTextChange: function handleTextChange(_ref) {
    var target = _ref.target;
    var value = target.value;
    this.props.onChange({
      text: value
    });
  },
  handleUrlChange: function handleUrlChange(_ref2) {
    var target = _ref2.target;
    var _this$props = this.props,
        url = _this$props.url,
        text = _this$props.text,
        showText = _this$props.showText;
    var onChange = this.props.onChange;
    var value = target.value;

    if (showText && url === text) {
      onChange({
        url: value,
        text: value
      });
      return;
    }

    onChange({
      url: value
    });
  },
  handleNoFollowChange: function handleNoFollowChange(_ref3) {
    var target = _ref3.target;
    this.props.onChange({
      isNoFollow: target.checked
    });
  },
  handleTargetChange: function handleTargetChange(_ref4) {
    var target = _ref4.target;
    this.props.onChange({
      isTargetBlank: target.checked
    });
  },
  canSubmit: function canSubmit() {
    var _this$props2 = this.props,
        showText = _this$props2.showText,
        text = _this$props2.text,
        url = _this$props2.url; // eslint-disable-next-line no-script-url

    var doesNotContainScript = url && url.indexOf('javascript:') === -1;
    var textIsNotEmpty = !showText || text && text.trim().length > 0;
    var urlIsNotEmpty = url && url.trim().length > 0;
    return urlIsNotEmpty && textIsNotEmpty && doesNotContainScript;
  },
  shouldDisplayPages: function shouldDisplayPages() {
    return this.props.pages.length > 0;
  },
  renderFooter: function renderFooter() {
    var _this$props3 = this.props,
        isNew = _this$props3.isNew,
        onCancel = _this$props3.onCancel,
        onConfirm = _this$props3.onConfirm;
    var saveText = isNew ? toI18nText('apply') : toI18nText('save');
    return _react.default.createElement(_UIPopoverFooter.default, {
      className: "p-top-4"
    }, _react.default.createElement(_UIButton.default, {
      use: "tertiary",
      size: "extra-small",
      "data-selenium-test": "communicator-link-apply",
      disabled: !this.canSubmit(),
      onClick: onConfirm
    }, saveText), _react.default.createElement(_UIButton.default, {
      use: "tertiary-light",
      size: "extra-small",
      onClick: function onClick() {
        return onCancel();
      }
    }, toI18nText('cancel')), this.renderRemove());
  },
  renderVisitLink: function renderVisitLink() {
    var _this$props4 = this.props,
        isNew = _this$props4.isNew,
        url = _this$props4.url;

    if (!isNew) {
      return _react.default.createElement(_UILink.default, {
        href: url,
        external: true
      }, toI18nText('visitLink'));
    }

    return null;
  },
  renderText: function renderText() {
    var _this$props5 = this.props,
        text = _this$props5.text,
        showText = _this$props5.showText;

    if (!showText) {
      return null;
    }

    return _react.default.createElement(_UIFormControl.default, {
      label: toI18nText('text'),
      className: "m-top-1"
    }, _react.default.createElement(_UITextInput.default, {
      className: "hs-input",
      "data-selenium-test": "communicator-link-text",
      onChange: this.handleTextChange,
      onKeyDown: this.cancelOrConfirmKeys,
      value: text
    }));
  },
  renderNoFollow: function renderNoFollow() {
    var _this$props6 = this.props,
        isNoFollow = _this$props6.isNoFollow,
        hideNoFollowConfiguration = _this$props6.hideNoFollowConfiguration;
    return hideNoFollowConfiguration ? null : _react.default.createElement(_UIFormControl.default, {
      className: "m-top-2 LinkForm__no-follow-ui"
    }, _react.default.createElement(_UICheckbox.default, {
      checked: isNoFollow,
      onChange: this.handleNoFollowChange,
      innerPadding: "none"
    }, _react.default.createElement(_Small.default, null, toI18nText('noFollow'))));
  },
  renderTarget: function renderTarget() {
    var _this$props7 = this.props,
        isTargetBlank = _this$props7.isTargetBlank,
        hideTargetConfiguration = _this$props7.hideTargetConfiguration;
    return hideTargetConfiguration ? null : _react.default.createElement(_UIFormControl.default, {
      className: "m-top-2 LinkForm__target-ui"
    }, _react.default.createElement(_UICheckbox.default, {
      checked: isTargetBlank,
      onChange: this.handleTargetChange,
      innerPadding: "none"
    }, _react.default.createElement(_Small.default, null, toI18nText('openInNewTab'))));
  },
  renderRemove: function renderRemove() {
    var _this$props8 = this.props,
        isNew = _this$props8.isNew,
        onRemove = _this$props8.onRemove;

    if (!isNew) {
      return _react.default.createElement(_UIButton.default, {
        use: "link",
        onClick: onRemove
      }, toI18nText('removeLink'));
    }

    return null;
  },
  renderHeader: function renderHeader() {
    var isNew = this.props.isNew;
    var headerText = this.props.headerText;

    if (isNew) {
      headerText = toI18nText('newLink');
    }

    return _react.default.createElement(_UIPopoverHeader.default, null, _react.default.createElement(_UIFlex.default, {
      direction: "row",
      align: "baseline",
      justify: "between"
    }, _react.default.createElement("h5", null, headerText || toI18nText('editLink')), this.renderVisitLink()));
  },
  renderUrl: function renderUrl() {
    var _this$props9 = this.props,
        onChange = _this$props9.onChange,
        pages = _this$props9.pages,
        showText = _this$props9.showText,
        text = _this$props9.text,
        url = _this$props9.url;

    if (this.shouldDisplayPages()) {
      return _react.default.createElement(_LinkFormPagesSelector.default, {
        onChange: onChange,
        pages: pages,
        showText: showText,
        text: text,
        url: url
      });
    }

    return _react.default.createElement(_UIFormControl.default, {
      label: toI18nText('url'),
      className: "m-top-1"
    }, _react.default.createElement(_UITextInput.default, {
      autoFocus: true,
      className: "hs-input",
      "data-selenium-test": "communicator-link-url",
      onChange: this.handleUrlChange,
      onKeyDown: this.cancelOrConfirmKeys,
      value: url
    }));
  },
  render: function render() {
    var onConfirm = this.props.onConfirm;
    var width = this.shouldDisplayPages() ? PAGES_POPOVER_WIDTH : POPOVER_WIDTH;
    return _react.default.createElement("div", {
      style: {
        width: width
      }
    }, this.renderHeader(), _react.default.createElement(_UIPopoverBody.default, {
      className: "p-top-2"
    }, _react.default.createElement("form", {
      onSubmit: onConfirm
    }, this.renderText(), this.renderUrl(), _react.default.createElement("div", {
      className: "m-top-2"
    }, this.renderTarget(), this.renderNoFollow()))), this.renderFooter());
  }
});

exports.default = _default;
module.exports = exports.default;